import script from "./GuestList.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestList.vue?vue&type=script&setup=true&lang=js"

import "./GuestList.vue?vue&type=style&index=0&id=5f2ff3aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f2ff3aa"]])

export default __exports__